import { render, staticRenderFns } from "./PaymentCard.vue?vue&type=template&id=15aaae3e"
import script from "./PaymentCard.vue?vue&type=script&lang=js"
export * from "./PaymentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports